<template>
  <!-- :before-close="hide" -->
  <el-dialog :visible.sync="showUserLogin" width="450px" :lock-scroll="false" :close-on-click-modal="false"
    class="user-login">
    <template #title>
      <div class="title">有看投，让投资大有看头</div>
    </template>
    <div class="tip">未注册手机验证后自动登录</div>
    <div class="form">
      <div class="form-item" :class="{ 'form-error': phoneError }">
        <el-input v-model="phone" placeholder="请输入手机号"></el-input>
      </div>
      <div v-if="codeImageUrl" class="form-item" :class="{ 'form-error': imageCodeError }">
        <el-input v-model="imageCode" placeholder="输入图片验证码"></el-input>
        <a class="btn-send" @click="getVerificationImage">
          <img :src="`data:image/png;base64,${codeImageUrl}`" />
        </a>
      </div>
      <div class="form-item" :class="{ 'form-error': passwordError }">
        <el-input v-model="password" placeholder="输入验证码"></el-input>
        <button class="get-code" :class="{ 'get-code--disable': disableSeedCodeBtn }" @click="sendSmsCode">
          {{ sendCodeBtnText }}
        </button>
      </div>
      <div class="error-text s5 c1">{{ errorText }}</div>

      <div class="button-login-wrapper">
        <el-button type="primary" class="button-login" @click="login" :loading="loading">登录</el-button>
      </div>

      <!-- <div class="agreement">
        注册或登录即代表同意有看投
        <a>隐私政策</a>和
        <a>用户协议</a>
      </div>-->
    </div>
  </el-dialog>
</template>

<script>
import { getVerificationImage, login, sendSmsCode } from '@/api/account'
import dayjs from 'dayjs'
import store from '@/store'
import router from '@/router'

function validatePhone(phone) {
  return /^1\d{10}$/.test(phone)
}

export default {
  name: 'UserLogin',
  data() {
    return {
      showUserLogin: false,
      sendCodeBtnText: '获取验证码',
      loading: false,
      errorText: '',
      disableSeedCodeBtn: false,
      phone: '',
      imageCode: '',
      password: '',
      imageKey: '',
      codeImageUrl: '',
      phoneError: false,
      passwordError: false,
      imageCodeError: false
    }
  },
  watch: {
    phone(val) { }
  },
  methods: {
    show() {
      this.showUserLogin = true
    },
    hide(isRedirect = true) {
      isRedirect && router.push('/')
      this.showUserLogin = false
    },
    startCountDown() {
      this.disableSeedCodeBtn = true
      const startTime = dayjs()

      const setCountDown = () => {
        const currentTime = dayjs()
        const countDown = 60 - currentTime.diff(startTime, 'second')
        if (countDown > 0) {
          this.sendCodeBtnText = countDown + 's 后重发'
          this.timeOut = setTimeout(setCountDown, 500)
        } else {
          this.disableSeedCodeBtn = false
          this.sendCodeBtnText = '重新发送'
        }
      }

      setCountDown()
    },
    clearCountDown() {
      clearTimeout(this.timeOut)
      this.timeOut = null
      this.disableSeedCodeBtn = false
      this.sendCodeBtnText = '重新发送'
    },
    async sendSmsCode() {
      if (this.disableSeedCodeBtn) return

      if (!validatePhone(this.phone)) {
        this.errorText = '请输入正确的手机号'
        this.phoneError = true
        return
      }

      this.phoneError = false

      this.startCountDown()

      const { result, detail } = await sendSmsCode(
        this.phone,
        this.imageKey,
        this.imageCode
      )
      switch (result.code) {
        case 0:
          // this.startCountDown()
          this.imageCodeError = false
          break
        case 7:
          this.imageCodeError = true
          this.errorText = '图形验证码校验失败'
          this.clearCountDown()
          break
        case 22201:
          this.imageCodeError = true
          this.errorText = '需要图片验证码'
          this.clearCountDown()

          await this.getVerificationImage()
          break
        default:
          this.errorText = detail ? detail.key : result.msg
          this.clearCountDown()
      }
    },
    async getVerificationImage() {
      const { result, detail } = await getVerificationImage()

      if (result.code === 0) {
        this.imageKey = detail.key
        this.codeImageUrl = detail.image
      }
    },
    async login() {
      if (!validatePhone(this.phone)) {
        this.errorText = '请输入正确的手机号'
        this.phoneError = true
        return
      }
      this.phoneError = false

      if (!/^\d{6}$/.test(this.password)) {
        this.errorText = '请输入正确的验证码'
        this.passwordError = true
        return
      }
      this.passwordError = false

      this.loading = true
      const { result, detail } = await login(
        this.phone,
        this.password,
        dayjs(+process.env.VUE_APP_VERSION).format('YYYY.M.D')
      )

      this.loading = false

      if (result.code === 0) {
        delete detail.accId
        store.commit('auth/setLoginInfo', detail)
        // 获取用户基础信息
        store.dispatch('user/getUserInfo')
        // 获取权限
        store.dispatch('right/getAllRightList')

        this.hide(false)

        this.$notify({
          title: '通知',
          message: '登录成功',
          type: 'success'
        })

        setTimeout(() => router.go(0), 200)
      } else {
        this.errorText = result.msg
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-login {
  ::v-deep {
    .el-dialog {
      background: #ffffff url('./images/login-bg.png') no-repeat top;
      background-size: 100% auto;
    }

    .el-dialog__body {
      padding-bottom: 20px;
    }

    .el-input__inner {
      border-width: 0 0 1px 0;
      border-radius: 0;
      background-color: transparent;
    }
  }
}

.form-error {
  ::v-deep {
    .el-input__inner {
      border-color: #e64c2e;
    }
  }
}

.title {
  margin: 20px 0;
  padding-top: 64px;
  font-size: 16px;
  color: #858585;
  text-align: center;
  background: url('~@/assets/images/common/logo.png') no-repeat top;
  background-size: 52px auto;
}

.tip {
  font-size: 12px;
  color: #858585;
}

.form {
  margin-top: 20px;

  .form-item {
    display: flex;
    margin-bottom: 20px;
  }
}

.btn-send {
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    cursor: pointer;
  }
}

.get-code {
  width: 120px;
  background-color: transparent;
  font-size: 14px;
  color: #046bcc;
  outline: none;
  border: none;
  cursor: pointer;

  &.get-code--disable {
    cursor: no-drop;
    pointer-events: none;
  }
}

.button-login-wrapper {
  padding-top: 50px;
  padding-bottom: 140px;
  text-align: center;
}

.button-login {
  width: 320px;
  height: 46px;
  background-color: #046bcc;
  border-radius: 5px;
  margin: 0 auto;
}

.agreement {
  font-size: 12px;
  color: #858585;
  text-align: center;

  a {
    color: #046bcc;
  }
}

.error-text {
  height: 40px;
  display: flex;
  text-align: left;
  font-size: 12px;
  color: #e64c2e;
}
</style>
